module.exports = __webpack_public_path__ + "6694f29a6abfecae318010d00de5980c.jpg";